import { BaseLayout } from "./base-layout";

export const SidebarLayout = () => {
  return (
    <BaseLayout
      isDealLayout={false}
      outletContext={undefined}
      isLoading={false}
    />
  );
};
